import { useState } from "react"
import { BiChevronDown, BiChevronUp, BiErrorCircle } from "react-icons/bi"
import "./styles2.css"

const HabilidadesIndividuais = (props) => {
  const { data, onClick, backgroundColor } = props

  const [isActive, setIsActive] = useState(false)

  return (
    <div>
      <div className="result-content">
        <div className="result-title">
          <div
            className="result-button"
            onClick={() => onClick()}
            style={{ backgroundColor }}
          />

          {data.name}
          <br></br>
        </div>
        <div className="result-description">
          <div className="text-description">
            <div>{data.description}</div>
          </div>

          <div className="details-description">
            <div className="details-ability">
              <b>Habilidade {data.ability}:&nbsp;</b> Nível {data.ability_score}
            </div>

            {data.subscore ? (
              <div>
                <b>Subnível : </b> {data.subscore}
              </div>
            ) : null}

            {data.category ? (
              <div className="details-etiqueta">
                <b>Categoria:</b>
                <div className="etiqueta">{data.category}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HabilidadesIndividuais
